import { render, staticRenderFns } from "./FullIndex.vue?vue&type=template&id=003951fa&scoped=true"
import script from "./FullIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./FullIndex.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FullIndex.vue?vue&type=style&index=0&id=003951fa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "003951fa",
  null
  
)

export default component.exports